import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const VoucherModal = Record({
    isVisible: false,
    institutionId: undefined,
    recurringPaymentId: undefined,
    billPayerId: null,
    searchResults: List(),
    saving: false,
    deleting: false,
    searching: false,
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) =>
            state.merge({
                isVisible: true,
                institutionId: payload.institutionId,
                recurringPaymentId: payload.recurringPaymentId,
                billPayerId: payload.billPayerId,
            }),
        [Actions.hide.type]: () => new VoucherModal(),
        [Actions.search.type]: state =>
            state.merge({
                searching: true,
            }),
        [Actions.searchSuccess.type]: (state, {payload}) =>
            state.merge({
                searchResults: payload.billPayers,
                searching: false,
            }),
        [Actions.searchFailed.type]: state =>
            state.merge({
                searching: false,
            }),
        [Actions.save.type]: state => state.merge({saving: true}),
        [Actions.saveSuccess.type]: () => new VoucherModal(),
        [Actions.saveFailed.type]: state => state.merge({saving: false}),
        [Actions.deletePayment.type]: state => state.merge({deleting: true}),
        [Actions.deletePaymentSuccess.type]: () => new VoucherModal(),
        [Actions.deletePaymentAborted.type]: state => state.merge({deleting: false}),
        [Actions.deletePaymentFailed.type]: state => state.merge({deleting: false}),
    },
    new VoucherModal(),
);
